/* eslint-disable sort-keys */
/**
 * King Living MegaMenu Theme
 *
 * Global mega menu styling system:
 * - Desktop: Trigger button styles, link text, popover content positioning
 * - Mobile: Panel styles, drawer footer styles
 *
 * @override Extends Chakra UI theme
 */

const MegaMenu = {
  parts: [
    // Desktop styles
    'desktopTriggerButton',
    'desktopLinkText',
    'desktopPopoverContent',
    'saleBadge',
    // Mobile styles
    'accountNameBadge',
    'logoMobileWrapper',
    'logoMobile',
    'mobilePanel',
    'mobilePanelContent',
    'mobileDrawerFooter',
    'mobileDrawerFooterStack',
    // Shared styles
    'menuItemLink',
    'menuItemButton',
    'menuItemText',
    'menuItemContainer',
    'menuItemIcon',
    'menuItemImages'
  ],

  baseStyle: (props = {}) => {
    const {level = 0, isDesktop, popoverTop} = props;

    // Level-based text styles
    const getTextStyles = () => {
      switch (level) {
        case 0:
          return {
            fontSize: 'md',
            fontWeight: 'semibold',
          };
        case 1:
          return {
            fontSize: 'sm',
            fontWeight: 'medium',
          };
        default:
          return {
            fontSize: 'xs',
            fontWeight: 'regular',
          };
      }
    };

    return {
      // Desktop styles
      desktopTriggerButton: {
        _hover: {opacity: 0.7},
        alignItems: 'center',
        display: 'flex',
        fontSize: 'md',
        fontWeight: 'semibold',
      },

      desktopLinkText: {
        fontSize: 'md',
        fontWeight: 'semibold',
      },

      desktopPopoverContent: {
        width: '100vw',
        maxWidth: '100vw',
        minWidth: '100vw',
        left: '0 !important',
        right: '0 !important',
        marginLeft: '0 !important',
        marginRight: '0 !important',
        marginTop: '0 !important',
        paddingTop: '0 !important',
        padding: 0,
        transform: 'none !important',
        zIndex: 1000,
        position: 'fixed',
        // Dynamic top positioning based on trigger element's bottom
        top: isDesktop && popoverTop > 0 ? `${popoverTop}px !important` : 'auto',
      },

      saleBadge: {
        display: 'inline-block',
        backgroundColor: '#BF1619',
        borderRadius: 'md',
        height: '10px',
        width: '10px',
        marginRight: '4px',
      },

      // Mobile styles
      accountNameBadge: {
        backgroundColor: 'white',
        borderRadius: '20px',
        color: 'brandColors.greyscale80',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '20px',
        height: '20px',
        fontSize: '11px',
      },
      logoMobile: {
        width: '100%',
        height: 'auto',
      },
      logoMobileWrapper: {
        maxWidth: {base: '76px', lg: '112px'},
      },
      mobilePanel: {
        bg: 'white',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        left: 0,
        position: 'absolute',
        top: 0,
        transition: 'transform 0.3s ease-in-out',
        width: '100%',
      },

      mobilePanelContent: {
        flex: 1,
        overflowY: 'auto',
        p: 4,
      },

      mobileDrawerFooter: {
        borderColor: 'gray.200',
        borderTop: '1px solid',
        p: 4,
      },

      mobileDrawerFooterStack: {
        alignItems: 'flex-start',
        spacing: 0,
      },

      // Shared styles
      menuItemLink: {
        alignItems: 'center',
        color: 'brandColors.greyscale90',
        justifyContent: 'space-between',
        textDecoration: 'none',
        width: '100%',
        _hover: {
          color: 'brandColors.primaryDarkLinen',
          textDecoration: 'underline',
        },
      },

      menuItemButton: {
        alignItems: 'center',
        bg: 'transparent',
        border: 'none',
        cursor: 'pointer',
        justifyContent: 'space-between',
        p: 0,
        textAlign: 'left',
        width: '100%',
      },

      menuItemText: {
        ...getTextStyles(),
      },

      menuItemContainer: {
        // Container for nested items
        ml: 4,
        mt: 2,
      },

      menuItemIcon: {
        boxSize: 4,
        ml: 2,
      },

      menuItemImages: {
        alignItems: 'center',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 2,
        mt: 2,
      },
    };
  },
};

export default MegaMenu;
